/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MatrixHazardScoreDefinitionDto } from '../models/MatrixHazardScoreDefinitionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class MatrixHazardScoreDefinitionControllerService {

    /**
     * @param id
     * @param requestBody
     * @returns MatrixHazardScoreDefinitionDto OK
     * @throws ApiError
     */
    public static updateMatrixScoreDefinitions(
        id: string,
        requestBody: MatrixHazardScoreDefinitionDto,
    ): CancelablePromise<MatrixHazardScoreDefinitionDto> {
        return __request({
            method: 'PUT',
            path: `/risk-assessments/matrix-score-definitions/${id}`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteAllMatrixScoreDefinitions(
        id: string,
    ): CancelablePromise<any> {
        return __request({
            method: 'DELETE',
            path: `/risk-assessments/matrix-score-definitions/${id}`,
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns MatrixHazardScoreDefinitionDto OK
     * @throws ApiError
     */
    public static updateFirmMatrixScoreDefinitions(
        id: string,
        requestBody: MatrixHazardScoreDefinitionDto,
    ): CancelablePromise<MatrixHazardScoreDefinitionDto> {
        return __request({
            method: 'PUT',
            path: `/firms/risk-assessments/matrix-score-definitions/${id}`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns MatrixHazardScoreDefinitionDto OK
     * @throws ApiError
     */
    public static getAllMatrixScoreDefinitions(): CancelablePromise<Array<MatrixHazardScoreDefinitionDto>> {
        return __request({
            method: 'GET',
            path: `/risk-assessments/matrix-score-definitions`,
        });
    }

    /**
     * @param requestBody
     * @returns MatrixHazardScoreDefinitionDto OK
     * @throws ApiError
     */
    public static saveMatrixScoreDefinitions(
        requestBody: MatrixHazardScoreDefinitionDto,
    ): CancelablePromise<MatrixHazardScoreDefinitionDto> {
        return __request({
            method: 'POST',
            path: `/risk-assessments/matrix-score-definitions`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns MatrixHazardScoreDefinitionDto OK
     * @throws ApiError
     */
    public static getAllFirmMatrixScoreDefinitions(): CancelablePromise<Array<MatrixHazardScoreDefinitionDto>> {
        return __request({
            method: 'GET',
            path: `/firms/risk-assessments/matrix-score-definitions`,
        });
    }

}